module.exports = __webpack_public_path__ + "static/fonts/remixicon.31d28485.31d28485.eot";